import React from 'react';
// import CV from '../../assets/cv_meri_gogichashvili.pdf';
import {IoMdDownload} from 'react-icons/io'
const CTA = () => {
  return (
    <div className="cta">
      <a id='talk' className="btn btn-primary" href="https://drive.google.com/file/d/1NaA0EquH81vnlUhghO-AejbAierSGOHF/view?usp=sharing" 
      target="_blank" 
      rel='noreferrer' >Preview CV </a>
      <a 
      // href="https://drive.google.com/file/d/1-S-7Hp4-HSH1pGCicSSqcsVt90gG0Dv9/view" 
      href="./Vivek_Nemade v3.pdf"
      target="_blank" 
      download 
      className="btn" id='CV'>
        Download CV
      </a>
      
      {/* <a href="#contact" id='talk' className="btn btn-primary">
        Let's talk
      </a> */}
    </div>
  );
};

export default CTA;
